// src/config/notificationConfig.js
import { FaTicketAlt, FaMicroscope, FaIndustry } from "react-icons/fa";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { BiPurchaseTag } from "react-icons/bi";
import { FcApproval, FcSalesPerformance, } from "react-icons/fc";
import { GoBeaker } from "react-icons/go";
import { CiSettings } from "react-icons/ci";

// Mapeamento de módulos e suas configurações
export const NOTIFICATION_MODULES = {
    HELPDESK: {
        id: 'helpdesk',
        name: 'Help Desk',
        icon: <FaTicketAlt />,
        color: '#4a90d9',
        description: 'Notificações de tickets de suporte',
        routes: {
            main: '/helpdesk',
            detail: '/helpdesk/gerenciamento-de-tickets'
        }
    },
    CHAT: {
        id: 'chat',
        name: 'Chat',
        icon: <IoChatboxEllipsesOutline />,
        color: '#9b59b6',
        description: 'Notificações de mensagens e conversas',
        routes: {
            main: '/chat'
        },
        isOverlay: true,
        needsChannelId: true
    },
    PURCHASE_REQUEST: {
        id: 'requisicao_de_compra',
        name: 'Requisição de Compra',
        icon: <BiPurchaseTag />,
        color: '#e67e22',
        description: 'Notificações de solicitações de compra',
        routes: {
            main: '/pedidos/requisicao-de-compra',
            detail: '/pedidos/requisicao-de-compra'
        }
    },
    // ✅ PURCHASE ORDER APPROVAL
    PURCHASE_ORDER_APPROVAL: {
        id: 'aprovacao_de_pedido_de_compra',
        name: 'Aprovação de Pedido de Compra',
        icon: <FcApproval />,
        color: '#27ae60',
        description: 'Notificações de pedidos de compra aguardando aprovação',
        routes: {
            main: '/pedidos/aprovacao-de-pedido-de-compra',
            detail: '/pedidos/aprovacao-de-pedido-de-compra'
        }
    },
    // ✅ SALES ORDER
    SALES_ORDER: {
        id: 'pedido_de_venda',
        name: 'Pedido de Venda',
        icon: <FcSalesPerformance />,
        color: '#2980b9',
        description: 'Notificações de pedidos de venda',
        routes: {
            main: '/pedidos/pedido-de-venda',
            detail: '/pedidos/pedido-de-venda'
        }
    },
    // ✅ SALES ORDER APPROVAL
    SALES_ORDER_APPROVAL: {
        id: 'aprovacao_de_pedido_de_venda',
        name: 'Aprovação de Pedido de Venda',
        icon: <FcApproval />,
        color: '#28a745',
        description: 'Notificações de pedidos de venda aguardando aprovação',
        routes: {
            main: '/pedidos/aprovacao-de-pedido-de-venda',
            detail: '/pedidos/aprovacao-de-pedido-de-venda'
        }
    },
    DEVELOPMENT: {
        id: 'desenvolvimento',
        name: 'Desenvolvimento de Projetos',
        icon: <GoBeaker />,
        color: '#6f42c1',
        description: 'Notificações de projetos de desenvolvimento',
        routes: {
            main: '/projeto/desenvolvimento',
            detail: '/projeto/desenvolvimento'
        }
    },
    PROJECT_STATUS: {
        id: 'acompanhamento_de_projeto',
        name: 'Acompanhamento de Projetos',
        icon: <FaMicroscope />,
        color: '#17a2b8',
        description: 'Notificações de status de projetos de desenvolvimento',
        routes: {
            main: '/projeto/acompanhamento-de-projeto',
            detail: '/projeto/acompanhamento-de-projeto'
        }
    },
    PRODUCTION_ORDER: {
        id: 'ordens_de_producao',
        name: 'Ordens de Produção',
        icon: <FaIndustry />,
        color: '#e67e22',
        description: 'Notificações de ordens de produção',
        routes: {
            main: '/producao/ordens-de-producao',
            detail: '/producao/ordens-de-producao'
        }
    },
    PRODUCTION_PHASE: {
        id: 'fases_de_producao',
        name: 'Fases de Produção',
        icon: <CiSettings />,
        color: '#f39c12',
        description: 'Notificações de fases de produção',
        routes: {
            main: '/producao/fases-de-producao',
            detail: '/producao/fases-de-producao'
        }
    }
};

// Mapeamento de roles para módulos permitidos
export const ROLE_MODULE_MAP = {
    'TI': ['helpdesk', 'chat'],
    'Diretoria (Admin)': [
        'helpdesk',
        'chat',
        'requisicao_de_compra',
        'aprovacao_de_pedido_de_compra',
        'pedido_de_venda',
        'aprovacao_de_pedido_de_venda',
        'desenvolvimento',
        'acompanhamento_de_projeto',
        'ordens_de_producao',
        'fases_de_producao'
    ],
    'Operacional': ['chat', 'desenvolvimento', 'acompanhamento_de_projeto', 'requisicao_de_compra', 'ordens_de_producao', 'fases_de_producao'],
    'Laboratório': ['chat', 'desenvolvimento', 'acompanhamento_de_projeto', 'ordens_de_producao', 'fases_de_producao'],
    'Logística': ['chat', 'ordens_de_producao', 'fases_de_producao'],
    'Comercial': ['chat'],
    'Adminstração': ['chat'],
    'Marketing': ['chat'],
    'Inspetor': ['chat'],
    'Usuário': ['chat']
};

// Mapeamento de prioridades para cores
export const PRIORITY_COLORS = {
    'Crítico': '#e74c3c',
    'Alta': '#f39c12',
    'Média': '#3498db',
    'Baixa': '#2ecc71'
};

// Obter módulos permitidos para um role
export const getModulePermissions = (role, customPermissions = []) => {
    const modules = ROLE_MODULE_MAP[role] || ['chat'];
    // Adicionar permissões customizadas se existirem
    const allModules = [...new Set([...modules, ...customPermissions])];
    return allModules.filter(module => NOTIFICATION_MODULES[module.toUpperCase()]);
};

// Obter configuração de um módulo
export const getModuleConfig = (moduleId) => {
    const key = moduleId.toUpperCase();
    return NOTIFICATION_MODULES[key] || {
        id: moduleId,
        name: moduleId.charAt(0).toUpperCase() + moduleId.slice(1),
        icon: '📌',
        color: '#6c757d',
        description: 'Módulo desconhecido'
    };
};

// Obter rota padrão para um módulo
export const getModuleDefaultRoute = (moduleId) => {
    const config = getModuleConfig(moduleId);
    return config.routes?.main || '/';
};

// Verificar se um módulo está disponível para um usuário
export const isModuleAvailable = (role, moduleId) => {
    const permissions = getModulePermissions(role);
    return permissions.includes(moduleId);
};